/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

const apiUrl = 'https://localhost:8091';
const authUrl = 'https://localhost:44335';
const frontUrl = 'http://localhost:4200';
const geoServerUrl = 'https://demo.map.cloud-twin.wlm.one/geoserver';

export const environment = {
  production: false,
  version: '1.0',
  copyright: '© 2022 Schneider Electric.',
  legalUrl: 'https://www.google.com',
  releaseDate: '2023-01-01 00:00',
  log: true,
  rxjsLog: false,
  application: {
    name: 'tc',
    logoUrl: '',
  },
  oAuthConfig: {
    issuer: authUrl,
    clientId: 'SimulationHub_App',
    dummyClientSecret: '1q2w3e*',
    scope: 'openid profile email simulationhub',
    showDebugInformation: true,
    oidc: true,
    requireHttps: true,
    response_type: 'code',
    redirectUri: `${frontUrl}/signin-oidc`,
  },
  apis: {
    default: {
      url: apiUrl,
    },
    interfaces: {
      url: apiUrl,
    },
    config: {
      url: `${apiUrl}/api/settings/frontend`,
    },
  },
  localization: {
    defaultResourceName: 'wlmux',
    forcedDateFormat: undefined,
    forcedHourFormat: undefined,
    defaultLocale: 'en-GB',
    availableLocales: ['es', 'en-GB', 'tr', 'it'],
  },
  headers: {
    spinnerHeader: 'X-Loading-Spinner',
  },
  defaultCacheDurationMinutes: 1440,
  endDateLowerEqual: false,
  increaseEndDate: true,
  minAllowedYear: 1700,
  uomConversionDecimals: 15,
  uomMinPositionsToKeepPrecision: 6,
  chartDisplaySymbolThreshold: 192,
  maxDecimalPositions: 3,
  geoServer: {
    url: geoServerUrl,
  },
  useMultitenant: true,
};
